function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
},
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M22 12a2 2 0 110 4c-2.895 0-6 3.105-6 6a2 2 0 11-4 0c0-5.105 4.895-10 10-10zM26 36a2 2 0 110-4c2.895 0 6-3.105 6-6a2 2 0 114 0c0 5.105-4.895 10-10 10z"
})),
/*#__PURE__*/
React.createElement("rect", {
  transform: "rotate(45 23.607 23.607)",
  x: 21.607,
  y: 8.607,
  width: 4,
  height: 30,
  rx: 2
}));

var SvgHuge = function SvgHuge(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 48,
      height: 48
    }, props), _ref)
  );
};

export default SvgHuge;